import { render, staticRenderFns } from "./reservationGroupList.vue?vue&type=template&id=7053cf70&scoped=true"
import script from "./reservationGroupList.vue?vue&type=script&lang=js"
export * from "./reservationGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7053cf70",
  null
  
)

export default component.exports